VP = window.VP || {};

(function( $ ) {
  var $window = $(window);

	// TypeCheck class (used by VP.helpers.checkIf)
	var TypeCheck = function ( entity ) {
		this.entity = entity;
	};
	TypeCheck.prototype = $.extend({}, TypeCheck.prototype, {
		is : function ( type ) {
			switch( type ) {
				case 'function': case Function:
					return typeof this.entity === 'function';
				case 'array': case Array:
					return Array.isArray(this.entity);
				case 'string': case String:
					return typeof this.entity === 'string';
				case 'number': case Number:
					return typeof this.entity === 'number';
				case undefined:
					return this.entity === undefined;
				case null:
					return this.entity === null;
				default:
					return this.entity instanceof type;
			}
		},
		isNot : function ( type ) {
			return !this.is( type );
		}
	});

	VP.helpers = {
    utmParam: null,
    updateHistoryState: null,
    desktopSize: 1200,
    window: $window,
    scrollingDown:false,
    lastScrollTop:0,
    indicators:0,
    mousedown:false,
    adchecktimer:null,
    env:"unknown",
    debug:false,

		init: function () {
      var _this = this;

      _this.debug = VP.helpers.getQParams("debug") == "1";
      _this.utmParam = window.location.href.split('/').pop().split('#')[0].split(".php").pop();
      _this.checkProportions();
      _this.eventHandlers();
      _this.setenv();


		},
    setenv: function() {
      var _this = this;
      switch(window.location.host) {
        case "visitphilly.com":
        case "www.visitphilly.com":
          _this.env = "live";
          break;
        case "stage.visitphilly.com":
        case "stagevp.wpengine.com":
        case "staging.visitphilly.com":
          _this.env = "stage";
          break;
        case "dev.visitphilly.com":
          _this.env = "dev";
          break;
      }
    },
    isLive: function() {
      return this.env == "live";
    },
    isStage: function() {
      return this.env == "stage";
    },
    isDev: function() {
      return this.env == "dev";
    },
    addIndicator: function ( position, label, id ) {
      var _this = this;
      if (!_this.isDev()) { // only for development debuging
        return;
      }
      if ( !id ) {
        id = Math.floor(Math.random() * 1000);
      }
      id = "indicator-"+id;
      _this.indicators = _this.indicators + 1;
      if ( !label ) {
        label = "Indicator " + _this.indicators;
      }

      position = parseInt(position);

      if (!$("#"+id).length) {
        // console.log("adding indicator: " + label);
        $("body").append("<div class='indicator' id='"+id+"'>"+label+"</div>");
      }


      $ind = $("#"+id);
      $ind.css("top",position);

    },
    eventHandlers: function() {
        var _this = this;

        $(document).on("mousedown", function() {
            _this.mousedown = true;
        }).on("mouseup",function() {
            _this.mousedown = false;  
        });


        VP.documentEvents.onScroll( _this.updateScrollDirection.bind( _this ), true );
        VP.documentEvents.onResize( _this.checkProportions.bind( _this ), true );
    },
    isMobileSize: function() {
      return ( VP.helpers.window.width() < VP.helpers.desktopSize );
    },
    isDesktopSize: function() {
      return ( VP.helpers.window.width() >= VP.helpers.desktopSize );
    },
	firecustomGTMEvent: function ( eventName , eventLabel, eventAction, eventCat, customVars ) {
        console.log("[fire GTM event] " + eventName + " | eventLabel: "  + eventLabel + " | eventAction: "+  eventAction + " | eventCat: "+  eventCat);
		window.dataLayer = window.dataLayer || [];

        var dataPush = {
            'event': eventName
        };

        if ( eventAction && eventAction != "") {
            dataPush['eventAction'] = $.trim(eventAction);
        }

        if ( eventLabel && eventLabel != "") {
            dataPush['eventLabel'] = $.trim(eventLabel);
        }

        if ( eventCat && eventCat != "") {
            dataPush['eventCat'] = $.trim(eventCat);
        }

        if ( customVars ) {
            $.each(customVars,function(a,b) {
                dataPush[a] = b;
            });
        }
        // console.log(dataPush);

        window.dataLayer.push(dataPush);
	},
    firecustomGTMTrack: function ( eventCat , eventLabel, eventAction, customVars ) {
			// console.log("firing GTM Track event: 'customTrack' : " + eventCat + " : " + eventAction + " : " + eventLabel );
		 	window.dataLayer = window.dataLayer || [];

      dataPush = {
        'event': "customTrack"
      };

      if ( eventCat && eventCat != "") {
        dataPush['eventCat'] = $.trim(eventCat);
      }

      if ( eventAction && eventAction != "") {
        dataPush['eventAction'] = $.trim(eventAction);
      }

      if ( eventLabel && eventLabel != "") {
        dataPush['eventLabel'] = $.trim(eventLabel);
      }

      if ( customVars ) {
        $.each(customVars,function(a,b) {
            dataPush[a] = b;
        });
      }
      // console.log(dataPush);

			window.dataLayer.push(dataPush);
		},
    checkProportions: function() {
       var _this = this;
       var _vidbox = $(".vp-featured-hero__video,.vp-category-hero__video,.vp-cinematic-hero__media-carousel");

       var _vidproportions = 9/16;

       if ($(".vp-category-hero__video").length) {
          _vidproportions = 1;
       }

       if ($(".vp-cinematic-hero__media-carousel").length) {
          _vidproportions = 3/4;
       }

       if (_vidbox.length == 1) {
         iswide = (_vidbox.width() / _vidbox.height()) > _vidproportions;

         if (iswide) {
            $("body").addClass("is-wide");
            $("body").removeClass("is-tall");
            return true;
         }
         else {
            $("body").removeClass("is-wide");
            $("body").addClass("is-tall");
            return false;
         }
       }
       return null;

    },
    updateScrollDirection: function() {
      var _this = this;
      var st = _this.window.scrollTop();
      if (st > _this.lastScrollTop){
         _this.scrollingDown = true;
         $("body").addClass("scrollingdown");
      } else {
        $("body").removeClass("scrollingdown");
        _this.scrollingDown = false;
     }
      _this.lastScrollTop = st;
    },
    updateState: function(itemNo, index, name, url) {
      var _this = this;
      window.clearTimeout( _this.updateHistoryState );
      // Set a timeout to run after scrolling ends
      _this.updateHistoryState = setTimeout(function() {
        // Run the callback
        history.replaceState( {item: itemNo, index: index}, name, url );

      }, 40);
    },

    zeronum: function(num) {
      if (num < 10 && num >= 0) {
        return "0" + num;
      }
      return num;
    },

  	getQParams: function ( qp ) {
        try {
          r=unescape(location.search.match(new RegExp(qp+"=+([^&]*)"))[1]);
        }
        catch ( e ) {
          r='';
        }
        return r;
    },
    //setQParams("param1","foo"); //pushes a new history state of ?param1=foo
    //setQParams({param1:"foo",param2:"bar"}); //pushes multiple changes
    //setQParams({param3:"another foo"},{type:"replace"}); //replace history instead of push
    setQParams: function ( key, value, options ) {
      var baseUrl         = [location.protocol, '//', location.host, location.pathname].join(''),
          q               = document.location.search,
          changes         = {},
          aType           = typeof(key),
          clear           = false;

      if(aType == "string"){
          changes[key] = value;
      }else if(aType == "object"){
          changes = key;
          options = value;
      }else if(key === false){
          clear = true;
      }
      //Options
      if(!options) options = {};
      var historyType     = options.type ? options.type : "push",
          state           = options.state ? options.state : {},
          title           = options.title ? options.title : "";

      if(clear){
          q = "";
      }else{
          var escapeRegExp = function(string){ return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')};
          for (var key in changes) {
              var value       = changes[key];
              var newParam    = key + '=' + encodeURIComponent(value);
              var updateRegex = new RegExp('([\?&])' + escapeRegExp(key) + '[^&]*');
              var removeRegex = new RegExp('([\?&])' + escapeRegExp(key) + '=[^&;]+[&;]?');

              if( typeof value == 'undefined' || value == null || value == '' ) { // Remove param if value is empty
                  q = q.replace(removeRegex, "$1");
                  q = q.replace( /[&;]$/, "" );
              } else if (q.match(updateRegex) !== null) { // If param exists already, update it
                  q = q.replace(updateRegex, "$1" + newParam);
              } else { // Otherwise, add it to end of query string
                  var join = q ? "&" : "?";
                  q = q + join + newParam;
              }
          }
      }

      if(q == "?") q = "";
      window.history[historyType+"State"](state, title, baseUrl + q);

      return !!q; //Return true if there's a query string, false otherwise
  	},
		debounce: function ( func, wait, immediate ) {
			var timeout;
			wait = wait || 100;
			return function() {
				var context = this, args = arguments;
				var later = function() {
					timeout = null;
					if (!immediate) { func.apply(context, args); }
				};
				var callNow = immediate && !timeout;
				clearTimeout(timeout);
				timeout = setTimeout(later, wait);
				if (callNow) { func.apply(context, args); }
			};
		},

		// Type checker
		//
		// @param {Mixed} something - The entity to check
		// @return	{} 		-
		//
		// USAGE:
		// VP.helpers.checkIf( someObject ).is( typetoCheck );
		// VP.helpers.checkIf( [] ).is( Array ) // -> true
		// VP.helpers.checkIf( [] ).is( 'array' ) // -> true
		checkIf: function ( something ) {
			return new TypeCheck( something );
		},

		/*
		 * Dynamically load a javascript from url
		 */
		loadScript: function (url, callback) {
		    jQuery.ajax({
		        url: url,
		        dataType: 'script',
		        success: callback,
		        async: true
		    });
		},

		isMobile: function() {
		  var check = false;
		  (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) {check = true;}})(navigator.userAgent||navigator.vendor||window.opera);
		  return check;
		},

    detectMobile: function () {
      var _iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
      var _supportsTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;

      var ua = navigator.userAgent.toLowerCase();
      var _Android = ua.indexOf("android") > -1;

      var _isMobile = this.isMobile();

      if ( true === _isMobile ) {
        $( 'body' ).addClass( 'is-mobile' );
      }

      if ( true === _Android ) {
        $( 'body' ).addClass( 'is-android' );
      }

      if ( true === _iOS ) {
        $( 'body' ).addClass( 'is-iOS' );
      }

      if ( true === _supportsTouch ) {
        $( 'body' ).addClass( 'has-touch' );
      }

    },

		/*
		 * Create a slug from a string
		 */
		slugify: function(text) {
			return text.toString().toLowerCase()
				.replace(/\s+/g, '-')			// Replace spaces with -
				.replace(/[^\w\-]+/g, '')		// Remove all non-word chars
				.replace(/\-\-+/g, '-')			// Replace multiple - with single -
				.replace(/^-+/, '')				// Trim - from start of text
				.replace(/-+$/, '');			// Trim - from end of text
		},
    forceAdRefresh: function( $container ) {
      var _this = this;
      var refresharray = [];
      $ads = $container.find(".vp-ads-465__ad,.vp-ads-300__ad"); // TODO: include other classes here
      if ( $ads.length ) {
         if ( gptadslots.length > 0 ) {
          $ads.each(function() {
            var adid =  $(this).attr("id");
            //console.log("[helpers : forceAdRefersh] found id :" + adid);
            $.each(gptadslots, function( i , slotobj ) {
              var slotid = slotobj.getSlotElementId();

              if (slotid == adid) {
               // console.log("[helpers : forceAdRefersh] match id :" + adid);
                refresharray.push(slotobj);
              }
            });

          });

        }
        if ( refresharray.length > 0 ) {
          if ( window.googletag ) {
            // console.log("[helpers : forceAdRefersh] refeshing array");
            // console.log( refresharray );
            googletag.pubads().refresh(refresharray,{changeCorrelator: false});
          }
        }
      }
      else {
          // console.log("[helpers : forceAdRefersh] No Ads found in container");
      }

    },
    checkAdRefresh: function( _recheck ) {
      var _this = this;
      var refresharray = [];
      if ( typeof(window.gptadslots) != "object" ) {
        return;
      }
      if ( gptadslots.length > 0 ) {
        $.each(gptadslots, function( i , slotobj ) {
          if ( typeof(slotobj.getHtml) == "function" ) {
            objhtml = slotobj.getHtml();
            if (objhtml == "") {
              // console.log("[helpers : checkAdRefresh] No Ad for slot: " + i);
              refresharray.push(slotobj);
            }
          }
        });
        if ( refresharray.length > 0 ) {
          if ( window.googletag ) {
            // console.log("[helpers : checkAdRefresh] refeshing array");
            // console.log( refresharray );
            googletag.pubads().refresh(refresharray,{changeCorrelator: false});
            if ( _recheck ) {
              _this.adchecktimer = setTimeout(function() {
                // run again to ensure ads are are refreshed
                _this.checkAdRefresh( true );
              },5000);
            }
          }
        }
        else {
          _this.adchecktimer = null;
          // console.log("[helpers : checkAdRefresh] all ads are okay");
        }
      }


    },
    //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
    //:::                                                                         :::
    //:::  This routine calculates the distance between two points (given the     :::
    //:::  latitude/longitude of those points). It is being used to calculate     :::
    //:::  the distance between two locations using GeoDataSource (TM) prodducts  :::
    //:::                                                                         :::
    //:::  Definitions:                                                           :::
    //:::    South latitudes are negative, east longitudes are positive           :::
    //:::                                                                         :::
    //:::  Passed to function:                                                    :::
    //:::    lat1, lon1 = Latitude and Longitude of point 1 (in decimal degrees)  :::
    //:::    lat2, lon2 = Latitude and Longitude of point 2 (in decimal degrees)  :::
    //:::    unit = the unit you desire for results                               :::
    //:::           where: 'M' is statute miles (default)                         :::
    //:::                  'K' is kilometers                                      :::
    //:::                  'N' is nautical miles                                  :::
    //:::                                                                         :::
    //:::  Worldwide cities and other features databases with latitude longitude  :::
    //:::  are available at https://www.geodatasource.com                         :::
    //:::                                                                         :::
    //:::  For enquiries, please contact sales@geodatasource.com                  :::
    //:::                                                                         :::
    //:::  Official Web site: https://www.geodatasource.com                       :::
    //:::                                                                         :::
    //:::               GeoDataSource.com (C) All Rights Reserved 2018            :::
    //:::                                                                         :::
    //:::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::::
    distance: function(lat1, lon1, lat2, lon2, unit) {
      if ((lat1 == lat2) && (lon1 == lon2)) {
        return 0;
      }
      else {
        var radlat1 = Math.PI * lat1/180;
        var radlat2 = Math.PI * lat2/180;
        var theta = lon1-lon2;
        var radtheta = Math.PI * theta/180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
          dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180/Math.PI;
        dist = dist * 60 * 1.1515;
        if (unit=="K") { dist = dist * 1.609344 }
        if (unit=="N") { dist = dist * 0.8684 }
        return dist;
      }
    },


    location: function(successfunction, failurefunction) {

        if ("geolocation" in navigator) {
          // check if geolocation is supported/enabled on current browser
          navigator.geolocation.getCurrentPosition(successfunction,failurefunction);
        } else {
          // geolocation is not supported
          // get your location some other way
          failurefunction('geolocation is not enabled on this browser');
        }
    },
    round: function(num, places) {
      num = parseFloat(num);
      var multiplier = Math.pow(10, places);
      return Math.round(num * multiplier) / multiplier;
    }


	};
})(jQuery);
